import React from 'react';
import CpfDataNascimento from './CpfDataNascimento';
import DoisFa from './DoisFa';
import { connect } from 'react-redux';

export class CpfDataNascimento2fa extends React.Component {
  state = {
    form: {cpf: '', dataNascimento: ''}
  }

  handleChangeInterno = (valid,data) => {
    this.setState({form: {...this.state.form, ...data}})
    this.props.handleFormChange(valid,data);
  }

  render() {
    return (
      <>
        <DoisFa
          handleNenhumaDasOpcoes={this.props.handleNaoEncontrado}
          isOpen={this.props.abre}
          onLogin={this.props.onLogin}
          onHide={this.props.handleFechou}
          incluirParticipanteHandle={this.props.incluirParticipanteHandle}
          params={this.state.form}
        />
        <CpfDataNascimento handleFormChange={this.handleChangeInterno} />
      </>
    );
  }
}

const mapStateToProps = store => ({
  evento: store.eventoState.evento.item
});

export default connect(mapStateToProps)(CpfDataNascimento2fa);
